'use client';

import { BookBase } from '@doist/icons/brand';
import { Box, Button, type ButtonProps } from '@doist/marketist';
import { StatsSection as HomeStatsSection } from 'app/components/stats-section/stats-section';
import { useTranslation } from 'app/i18n/client';
import cn from 'clsx';
import { ContainerTwoColumns } from 'components/container-two-column/container-two-column';
import { TextLockUp } from 'components/text-lock-up/text-lock-up';
import { useLocale } from 'next-intl';
import { todoistAge } from 'services/todoistAge';
import css from './stats-section.module.css';
export function StatsSection() {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'home-teams');
  const {
    years,
    days
  } = todoistAge();
  return <ContainerTwoColumns width="lg" breakAbove="xlg" padded data-sentry-element="ContainerTwoColumns" data-sentry-component="StatsSection" data-sentry-source-file="stats-section.tsx">
            <ContainerTwoColumns.BodyContainer data-sentry-element="unknown" data-sentry-source-file="stats-section.tsx">
                <Box className={css.copy} data-sentry-element="Box" data-sentry-source-file="stats-section.tsx">
                    <TextLockUp size="lg" title={t('statsTitle')} preheader={t('statsPreheader')} buttons={<ArticleLink bleed={true} startIcon={BookBase} />} data-sentry-element="TextLockUp" data-sentry-source-file="stats-section.tsx">
                        {t('statsDescriptionYears', {
            count: years
          })}{' '}
                        {t('statsDescriptionDays', {
            count: days
          })}{' '}
                        {t('statsDescriptionRestAssured')}
                    </TextLockUp>
                </Box>
            </ContainerTwoColumns.BodyContainer>
            <HomeStatsSection data-sentry-element="HomeStatsSection" data-sentry-source-file="stats-section.tsx" />
        </ContainerTwoColumns>;
}
function ArticleLink({
  className,
  bleed,
  startIcon
}: Partial<ButtonProps>) {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'home-teams');
  return <Button className={cn(css.articleLink, className)} variant="tertiary" size="large" target="_blank" startIcon={startIcon} bleed={bleed} href="https://blog.doist.com/no-exit-strategy/?utm_source=todoist&utm_medium=home&utm_campaign=new_td_landing_page_c2205" data-sentry-element="Button" data-sentry-component="ArticleLink" data-sentry-source-file="stats-section.tsx">
            {t('statsButtonText')}
        </Button>;
}